import { getAxiosInstance } from "../../../api";

export const updatePrintingForm = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/printing-report/old-certificate/save-updates`,
      body,
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const getFormData = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `/printing-report/old-certificate/edit-updated-data?item_details_id=${body?.item_details_id}&item_type_id=${body?.item_type_id}&process_slug=${body?.process_slug}`,
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const reissueBulkPass = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/printing-report/old-certificate/bulk-update`,
      body,
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};
